import { Image } from "@chakra-ui/react";
import React from "react";

const TopSection = () => {
  return (
    <div style={{ width: "85%", margin: "auto" }}>
      <Image src="https://drive.google.com/uc?export=view&id=19NxeE-8Ns7w8z0fusEh0zH0RQ2RRslhI" />
      <Image
        src="https://merchandising-assets.bestbuy.ca/bltc8653f66842bff7f/blt0ca797fe4791c852/61d8c3637c5435387a0c0115/heb-20220107-bby-valueprops-en-m.jpg"
        mt={"20px"}
      />
    </div>
  );
};

export default TopSection;
